/* global document */

import EasyPostConstants from 'app/easypost_constants';

export default function addAdroll() {
  const adrollAdvId = EasyPostConstants.AdrollAdvId;
  const adrollPixId = EasyPostConstants.AdrollPixId;

  if (adrollAdvId && adrollPixId) {
    const scr = document.createElement('script');
    const host = ((document.location.protocol === 'https:') ? 'https://s.adroll.com' : 'http://a.adroll.com');
    scr.setAttribute('async', 'true');
    scr.type = 'text/javascript';
    scr.src = `${host}/j/roundtrip.js`;
    ((document.getElementsByTagName('head') || [null])[0] || document.getElementsByTagName('script')[0].parentNode).appendChild(scr);
  }
}



// WEBPACK FOOTER //
// ./utils/adroll.js